module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5IDYiPgo8cmVjdCBmaWxsPSIjMjE0NjhCIiB3aWR0aD0iOSIgaGVpZ2h0PSI2Ii8+CjxyZWN0IGZpbGw9IiNGRkYiIHdpZHRoPSI5IiBoZWlnaHQ9IjQiLz4KPHJlY3QgZmlsbD0iI0FFMUMyOCIgd2lkdGg9IjkiIGhlaWdodD0iMiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-country-flags/svg/nl.svg
// module id = sgQp
// module chunks = 1